import { AppointmentType, DefaultAppointmentTypeList } from './appointmentType';

export interface ProviderDetails {
  practitionerId: string;
  cattailsProviderId: string;
  name?: string;
  appointmentTypeList?: AppointmentType[];
}

export const findAppointmentTypeInList = (
  appointmentTypeList?: AppointmentType[],
  apptTypeId?: string
) => {
  return appointmentTypeList?.find((apptType) => apptType.id === apptTypeId);
};

///////////////////////////////////////////////
// defaults for testing
export const DefaultTestProviderDetails: ProviderDetails = {
  practitionerId: '15937606',
  cattailsProviderId: '375',
  name: 'Provider Name',
  appointmentTypeList: DefaultAppointmentTypeList,
};
